import { render, staticRenderFns } from "./MPRDicomView.vue?vue&type=template&id=3a087088&scoped=true&"
import script from "./MPRDicomView.vue?vue&type=script&lang=js&"
export * from "./MPRDicomView.vue?vue&type=script&lang=js&"
import style0 from "./MPRDicomView.vue?vue&type=style&index=0&id=3a087088&scoped=true&lang=scss&"
import style1 from "./MPRDicomView.vue?vue&type=style&index=1&id=3a087088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a087088",
  null
  
)

export default component.exports